import Component from "@glimmer/component";
import { restartableTask, task } from "ember-concurrency";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";
import ConnectionDetails from "../components/connection-details";
import Firewall from "../components/firewall";
import Monitoring from "../components/monitoring";
import PitrBox from "../components/pitr-box";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class DatabasesDetailsOverview extends Component {
  @service http;
  @service store;

  get database() {
    return this.args.model.database;
  }

  get project() {
    return this.args.model.project;
  }

  fetchConnectionDetailsTask = restartableTask(async (username, databaseName) => {
    let response = await this.http.request({
      url: `${ENV.apiBaseUri}/database/connectiondetails?id=${this.database.id}&username=${username}&databasename=${databaseName}`,
    });

    return new URL(response.content.connectiondetails.connectionstring);
  });

  updateAccessTask = task(async (allowlist) => {
    this.database.allowlist = allowlist.split(/,\s*/).filter(Boolean);

    try {
      await this.store.request(saveRecord(this.database));
      return true;
    } catch (e) {
      this.database.rollbackAttributes();
      throw e;
    }
  });

  <template>
    <div class="grid gap-8 mt-8">
      <ConnectionDetails @database={{this.database}} @fetchConnectionDetails={{this.fetchConnectionDetailsTask}} />
      <PitrBox @database={{this.database}} @project={{this.project}} />
      <Firewall @database={{this.database}} @updateAccessTask={{this.updateAccessTask}} />
      <Monitoring @url={{this.database.monitoringUrl}} />
    </div>
  </template>
}
